import React from 'react';
import Hooks from '@benzinga/hooks';
import { scrollDelay } from '@benzinga/frontend-utils';
import { runningServerSide } from '@benzinga/utils';
import { isTaboolaAllowedToShow } from '@benzinga/article-manager';
import type { Mode } from '@benzinga/ads-utils';

const TaboolaPlacement = React.lazy(() =>
  import('@benzinga/ads').then(module => ({ default: module.TaboolaPlacement })),
);

export interface TaboolaSettings {
  placementMethod?: 'interval' | 'localStorage' | 'below-article';
  unitMode?: Mode;
  unitPlacement?: string;
  unitId?: string;
  unitKey?: string;
}

interface BelowArticlePartnerAdBlockI {
  taboolaSettings?: TaboolaSettings;
  articleIndex?: number;
  id: string | number;
  url: string;
  isPaywallActive?: boolean;
}

export const GetBelowArticlePartnerAdBlock = ({
  articleIndex,
  //id,
  isPaywallActive,
  taboolaSettings,
  url,
}: BelowArticlePartnerAdBlockI) => {
  const [shouldRenderPartnerAd, setShouldRenderPartnerAd] = React.useState<boolean>(false);

  Hooks.useEffectDidMount(() => {
    const loadPartnerBlocks = () => {
      scrollDelay(700, () => setShouldRenderPartnerAd(true));
    };

    if (document.readyState === 'complete') {
      loadPartnerBlocks();
    } else {
      window.addEventListener('load', loadPartnerBlocks);
    }
  });

  React.useEffect(() => {
    if (isPaywallActive) {
      setShouldRenderPartnerAd(true);
    }
  }, [isPaywallActive]);

  if (runningServerSide()) return null;
  if (!shouldRenderPartnerAd) return null;

  // const randomRotate = Math.random() >= 0.8;
  const isTaboolaAllowedToShowInterval = (articleIndex: number | undefined, interval: number) => {
    return articleIndex === 0 || (articleIndex && articleIndex % interval === 0);
  };

  const shouldRenderTaboola =
    taboolaSettings?.placementMethod === 'localStorage'
      ? isTaboolaAllowedToShow(articleIndex ?? 0)
      : taboolaSettings?.placementMethod === 'interval'
        ? isTaboolaAllowedToShowInterval(articleIndex, 3)
        : taboolaSettings?.placementMethod === 'below-article';

  return (
    <>
      {/*<SmartAssetWidget />*/}

      {shouldRenderTaboola && (
        <div className="taboola-wrapper overflow-hidden">
          <TaboolaPlacement
            id={taboolaSettings?.unitId || 'taboola-placement-0'}
            mode={taboolaSettings?.unitMode}
            placement={taboolaSettings?.unitPlacement}
            shouldFlush={false}
            unitKey={taboolaSettings?.unitKey}
            url={url}
            vizSensor={false}
          />
        </div>
      )}
    </>
  );
};
